import {Dispatch} from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IActionType,
  IAgentManagementUserResponseObject,
  IAgentManagementUsersNormalized,
  IAgentTitle,
  ICreateAgentOnlyReq,
  ICreateUpdateAgentManagementUserNormalizedReq,
  IGetQueryParams, ISelectDropdownOption,
  IZonesResponseObject,
} from "../../interfaces/Index";
import {
  createAgent,
  fetchAgentListApiCall,
  fetchAgentTeamApiCall,
  fetchAgentTitlepiCall,
  fetchBrandsApiCall,
  getAgentDetailsApiCall,
  getAllAgentZonesAPICall,
  updateAgent,
} from "../sources/AgentManagementSource";
import userSource, {UserAddUpdateDto,} from "../sources/UserSource";

export const fetchAgentListInit = () => ({
  type: actionTypes.GET_AGENT_MANAGEMENT_USERS_INIT,
});

export const fetchAgentListSuccess = (payload: Array<IAgentManagementUsersNormalized> | null) => ({
  type: actionTypes.GET_AGENT_MANAGEMENT_USERS_SUCCESS,
  payload,
});

export const fetchAgentListFail = (error: string | object | null) => ({
  type: actionTypes.GET_AGENT_MANAGEMENT_USERS_FAIL,
  error,
});

export const getUpdateAgentDetailInit = () => ({
  type: actionTypes.GET_AGENT_MANAGEMENT_USER_DETAIL_INIT,
});

export const getUpdateAgentDetailSuccess = (
  payload: Array<IAgentManagementUserResponseObject>
) => ({
  type: actionTypes.GET_AGENT_MANAGEMENT_USER_DETAIL_SUCCESS,
  payload,
});

export const getUpdateAgentDetailFail = (error: string | object | null) => ({
  type: actionTypes.GET_AGENT_MANAGEMENT_USER_DETAIL_FAIL,
  error,
});

export const fetchAllAgentZonesInit = () => ({
  type: actionTypes.GET_ALL_AGENT_TEAM_ZONES_INIT,
});

export const fetchAllAgentZonesSuccess = (
  payload: IZonesResponseObject[] | null
) => ({
  type: actionTypes.GET_ALL_AGENT_TEAM_ZONES_SUCCESS,
  payload,
});

export const fetchAllAgentZonesFail = (error: string | object | null) => ({
  type: actionTypes.GET_ALL_AGENT_TEAM_ZONES_FAIL,
  error,
});

export const createAgentManagementUserWithClientsAndRolesInit = () => ({
  type: actionTypes.CREATE_AGENT_MANAGEMENT_USERS_INIT,
});

export const createAgentManagementUserWithClientsAndRolesSuccess = () => ({
  type: actionTypes.CREATE_AGENT_MANAGEMENT_USERS_SUCCESS,
});

export const createAgentManagementUserWithClientsAndRolesFail = (
  error: string | object | null
) => ({
  type: actionTypes.CREATE_AGENT_MANAGEMENT_USERS_FAIL,
  error,
});

export const updateAgentManagementUserWithClientsAndRolesInit = () => ({
  type: actionTypes.UPDATE_AGENT_MANAGEMENT_USERS_INIT,
});

export const updateAgentManagementUserWithClientsAndRolesSuccess = () => ({
  type: actionTypes.UPDATE_AGENT_MANAGEMENT_USERS_SUCCESS,
});

export const updateAgentManagementUserWithClientsAndRolesFail = (
  error: string | object | null
) => ({
  type: actionTypes.UPDATE_AGENT_MANAGEMENT_USERS_FAIL,
  error,
});

export const getAgentTitleInit = () => ({
  type: actionTypes.GET_AGENT_TITLE_INIT,
});

export const getAgentTitleSuccess = (payload: Array<IAgentTitle>) => ({
  type: actionTypes.GET_AGENT_TITLE_SUCCESS,
  payload,
});

export const getAgentTitleFail = (error: string | object | null) => ({
  type: actionTypes.GET_AGENT_TITLE_FAIL,
  error,
});

export const getAgentTeamInit = () => ({
  type: actionTypes.GET_AGENT_TEAM_INIT,
});

export const getAgentTeamSuccess = (payload: Array<any>) => ({
  type: actionTypes.GET_AGENT_TEAM_SUCCESS,
  payload,
});

export const getAgentTeamFail = (error: string | object | null) => ({
  type: actionTypes.GET_AGENT_TEAM_FAIL,
  error,
});

export const getBrandsInit = () => ({
  type: actionTypes.GET_BRANDS_INIT,
});

export const getBrandsSuccess = (payload: Array<any>) => ({
  type: actionTypes.GET_BRANDS_SUCCESS,
  payload,
});

export const getBrandsFail = (error: string | object | null) => ({
  type: actionTypes.GET_BRANDS_FAIL,
  error,
});

// async actions
export const getAgentListAction = (queryParams?: IGetQueryParams) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(fetchAgentListInit());
  return fetchAgentListApiCall(queryParams)
    .then((agentManagementUsers: any) =>
      dispatch(fetchAgentListSuccess(agentManagementUsers))
    )
    .catch((e: object | null | string) => dispatch(fetchAgentListFail(e)));
};

export const getAgentDetailAction = (id: string) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(getUpdateAgentDetailInit());
  return getAgentDetailsApiCall(id)
    .then((details: any) => dispatch(getUpdateAgentDetailSuccess(details)))
    .catch((e: object | null | string) =>
      dispatch(getUpdateAgentDetailFail(e))
    );
};

export const getAllAgentZonesAction = (selectedCity?: string, customerChannel?: string, queryParams?: IGetQueryParams) => (
  dispatch: Dispatch<IActionType>
) => {
  dispatch(fetchAllAgentZonesInit());
  return getAllAgentZonesAPICall(selectedCity,customerChannel, queryParams)
    .then((data: IZonesResponseObject[]) =>
      dispatch(fetchAllAgentZonesSuccess(data))
    )
    .catch((e: object | null | string) => dispatch(fetchAllAgentZonesFail(e)));
};

export const createAgentWithTypeTeamZones = (
  payload: ICreateAgentOnlyReq
) => (dispatch: Dispatch<IActionType>) => {
  dispatch(createAgentManagementUserWithClientsAndRolesInit());
  return createAgent(payload)
    .then(() => dispatch(createAgentManagementUserWithClientsAndRolesSuccess()))
    .catch((e: object | null | string) =>
      dispatch(createAgentManagementUserWithClientsAndRolesFail(e))
    );
};

export const createAgentUserWithTypeTeamZones = (
  payload: ICreateUpdateAgentManagementUserNormalizedReq
) => (dispatch: Dispatch<IActionType>) => {
  dispatch(createAgentManagementUserWithClientsAndRolesInit());
  const createAgentPayload: any = {
    name: payload.agentName,
    phone: payload.phoneNumber.trim(),
    password: payload.password,
    passwordConfirmation: payload.confirmPassword,
    nationalId: payload.nationalId,
    email: payload.email,
  };
  return userSource
    .createUser(UserAddUpdateDto.fromCreateDto(null, createAgentPayload))
    .then((response) => {
      const teamTypeZone: any = {
        userId: response.id,
        title: payload.title,
        teamId: payload.teamId,
        agentName: payload.agentName,
        phoneNumber: payload.phoneNumber.trim(),
        customerChannel: payload.customerChannel,
        status: payload.status ? "ACTIVE" : "INACTIVE",
        zones: payload.zones,
        brands: payload.brands,
      };
      return createAgent(teamTypeZone);
    })
    .then(() => dispatch(createAgentManagementUserWithClientsAndRolesSuccess()))
    .catch((e: object | null | string) =>
      dispatch(createAgentManagementUserWithClientsAndRolesFail(e))
    );
};

export const updateAgentUserWithTypeTeamZones = (
  payload: ICreateUpdateAgentManagementUserNormalizedReq
) => (dispatch: Dispatch<IActionType>) => {
  dispatch(updateAgentManagementUserWithClientsAndRolesInit());
  const updateUserPayload: any = {
    name: payload.agentName,
    phone: payload.phoneNumber.trim(),
    nationalId: payload.nationalId,
    password: payload.password,
    passwordConfirmation: payload.confirmPassword,
    status: payload.status,
    email: payload.email,
  };
  
  const teamTypeZone: any = {
    userId: payload.userId,
    agentId: payload.agentId,
    title: payload.title,
    teamId: payload.teamId,
    agentName: payload.agentName,
    phoneNumber: payload.phoneNumber.trim(),
    customerChannel: payload.customerChannel,
    status: payload.status,
    zones: payload.zones,
    brands: payload.brands
  };
  return userSource
    .updateUser(
      payload.id as string,
      UserAddUpdateDto.fromUpdateDto(payload.id as string, updateUserPayload)
    )
    .then(() => {
      return updateAgent(payload.agentId as string, teamTypeZone);
    })
    .then(() => dispatch(updateAgentManagementUserWithClientsAndRolesSuccess()))
    .catch((e: object | null | string) =>
      dispatch(updateAgentManagementUserWithClientsAndRolesFail(e))
    );
};

export const fetchAgentTitle = () => (dispatch: Dispatch<IActionType>) => {
  dispatch(getAgentTitleInit());
  return fetchAgentTitlepiCall()
    .then((agentTitle: Array<IAgentTitle>) =>
      dispatch(getAgentTitleSuccess(agentTitle))
    )
    .catch((e: object | null | string) => dispatch(getAgentTitleFail(e)));
};

export const fetchAgentTeam = () => (dispatch: Dispatch<IActionType>) => {
  dispatch(getAgentTeamInit());
  return fetchAgentTeamApiCall()
    .then((agentTeam: Array<IAgentTitle>) =>
      dispatch(getAgentTeamSuccess(agentTeam))
    )
    .catch((e: object | null | string) => dispatch(getAgentTeamFail(e)));
};

export const fetchBrands = () => (dispatch: Dispatch<IActionType>) => {
  dispatch(getBrandsInit());
  return fetchBrandsApiCall()
      .then((brands: Array<IAgentTitle>) =>
          dispatch(getBrandsSuccess(brands))
      )
      .catch((e: object | null | string) => dispatch(getBrandsFail(e)));
};
